import React from 'react';
import { required, Toolbar, SaveButton, Filter, Create, Edit, List, Datagrid, TextField,
  TextInput, SimpleForm, SelectArrayInput, SelectInput, FormDataConsumer, ReferenceArrayInput, DateInput, DateField,
  AutocompleteArrayInput, downloadCSV, useListContext, TopToolbar, sanitizeListRestProps, Button, CreateButton, 
  ExportButton} from 'react-admin';
import DeleteWithConfirmation from './components/DeleteWithConfirmation';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import CloudDownload from '@material-ui/icons/CloudDownload';
import DataTable from 'react-data-table-component';
import { fetchUtils } from 'react-admin';
import { AlertComponent } from './components/alerts.js';
import jsonExport from 'jsonexport/dist';

const utils = require('./components/utils');
const dataSupport = require('./components/data_support.js');
const fetch = fetchUtils.fetchJson;

const BASE_URL = window.nobid_endpoint+'/adstxtreports_report'
const requestOptions = {headers: new Headers()}
requestOptions.headers.set('accept', 'application/json')
const token = localStorage.getItem('token');
requestOptions.headers.set('Authorization', `Bearer ${token}`);

const BASE_COLUMNS = [
  { name: 'Date', selector: 'date', sortable: true, cell: row => row.date },
  { name: 'Domain/App', selector: 'domain_name', sortable: true },
  { name: 'Bidder', selector: 'bidder_name', sortable: true },
  { name: '%Coverage Rate', selector: 'coverage_rate', alwaysOn: true, sortable: true, cell: row => <span>{ utils.formatDouble(row.coverage_rate, '%') }</span> },
  { name: 'Impressions', selector: 'impressions', sortable: true, cell: row => <span>{ utils.formatLong(row.impressions) }</span> },
  { name: '$Revenue', selector: 'revenue', sortable: true, cell: row => <span>{ utils.formatDouble(row.revenue) }</span> },
  { name: 'Adstxt Line', selector: 'match', sortable: true },
];
const defaultColumnSelectors = ['coverage_rate'];
const choicesType = [
  { id: 'site', name: 'Site'},
  { id: 'app', name: 'App'}
];
const choicesShow = [
  { id: 'date', name: 'Date'},
  { id: 'domain_name', name: 'Domain/App' },
  { id: 'bidder', name: 'Bidder' },
  { id: 'match', name: 'Adstxt Line' },
  { id: 'impressions', name: 'Impressions' },
  { id: 'revenue', name: 'Revenue' }
];
const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];
const exporter = sites => {
  const sitesForExport = sites.map(site => {
    let bidderAuditStatus = [];
    if (site.bidder_audit_status) for (const key of Object.keys(site.bidder_audit_status)) {
      const message = site.bidder_audit_status[key].message ? ` (${site.bidder_audit_status[key].message})` : '';
      bidderAuditStatus.push(`${key} ${site.bidder_audit_status[key].status}${message}`);
    }
    let o = {
        id: site.code,
        name: site.name,
        type: site.type,
        audit_status: bidderAuditStatus.join('|')
    };
    return o;
  });
  jsonExport(sitesForExport, {
      headers: ['id', 'name', 'type', 'audit_status', 'audit_reason']
  }, (err, csv) => {
      downloadCSV(csv, 'sites');
  });
};

const Title = ({ record }) => {
  return <span> Report {record && record.name ? `"${record.name}"` : 'Create Adstxt Coverage Report'} </span>
};
class CustomToolbar extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL
  };

  constructor(props) {
    super(props);
    this.parent = props.parent;
  }

  fetchData = () => {
    function updateState(that, headers, json) {
      if (json) for (let i in json) {
        let r = json[i];
        if (r.date && r.date.indexOf('T') > 0) r.date = r.date.substring(0, r.date.indexOf('T'))
      }

      const showList = formData.show || [];
      const columnSelectors = defaultColumnSelectors.concat(showList.flatMap(x=>[x, `${x}_id`, `${x}_name`, `${x}_group`]));

      that.parent.setState({
        data: json,
        saved_data:json,
        columns: BASE_COLUMNS.filter(c => columnSelectors.includes(c.selector)),
        loading: false});
    }

    function formDataFields(formData, fields) {
      const buf = [];
      for(let i in fields) {
        let field = fields[i];
        if (formData[field] && Array.isArray(formData[field]) && formData[field].length>0) {
          formData[field].map(x => buf.push(`${field}=${x}`));
        } else if (formData[field]) {
          buf.push(`${field}=${formData[field]}`);
        }
      }
      return buf.length>0 ? `&${buf.join('&')}` : '';
    }

    formData.show = formData.show || [];
    if (formData.show.includes('sales_rep') && !formData.show.includes('publisher')) {
      formData.show.push('publisher');
    }
    if (formData.show.includes('sales_rep') && !formData.show.includes('profit')) {
      formData.show.push('profit');
    }
    if (formData.show.includes('sales_rep')) {
      formData.show.push('sales_payout');
    }
    let show='';
    if (formData.show) formData.show.forEach(item => { show+='&show='+item; });

    this.parent.setState({ loading: true });
    let url = `${this.state.baseUrl}?${show}` +
      `${formDataFields(
          formData,
          ['interval', 'date_range', 'start_date', 'end_date', 'bidder_id', 'domain_id', 'type']
      )}`;
    const requestOptions = {headers: new Headers()}
    requestOptions.headers.set('accept', 'application/json')
    const token = localStorage.getItem('token');
    requestOptions.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, requestOptions).then(({ headers, json }) => {
    	updateState(this, headers, json)
    });
  }
  handleClick = () => {
	  this.fetchData();
  }

  render () {
    return (
      <Toolbar>
        <SaveButton style={{marginRight: '25px'}} variant='contained' 
          color='primary' disabled={this.parent.state.loading} {...this.props} />
        <Button label="Run Report" onClick={this.handleClick} props={this.props} variant="contained"
          style={{marginRight: '25px', padding: '7px', width: '160px'}} color="primary" startIcon={<RunReportIcon />} disabled={this.parent.state.loading}/>
      </Toolbar>
    )
  }
}
const ListActions = (props) => {
  const { className, maxResults, ...rest } = props;
  const { total } = useListContext();
  return (
      <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
          <CreateButton />
          <ExportButton disabled={total === 0} maxResults={10000} exporter={exporter}/>
      </TopToolbar>
  );
};
const ReportFilters = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="search_name" alwaysOn resettable />
  </Filter>
);
export const AdstxtReportList = (props) => (
	<List {...props} title="Domains" 
  perPage={25} 
  filters={<ReportFilters />}
  bulkActionButtons={false} 
  actions={<ListActions />}>
		<Datagrid rowClick="edit">
      <TextField source="name" label="Name" />
      <DateField source="updated_at" label="Update Date" />
      <DateField source="created_at" label="Creation Date" />
      <DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
let formData = {};
function setFormData(formdata) {
  formData = formdata;
}

class ReportComponent extends React.Component {
  state = {
    data: [],
    loading: false,
    total: 0,
    perPage: 25,
    params : ['_end=1000000', '_order=ASC', '_sort=id', '_start=0'],
    baseUrl: BASE_URL,
    dateRange: this.props.record.date_range
  };

  render() {
    const { loading, data, total, dateRange } = this.state;
    const { permissions } = this.props;
    return (
      <div>
        <AlertComponent />
        <SimpleForm toolbar={<CustomToolbar parent={this} />} style={{ width: '100%', backgroundColor: '#424242', borderRadius: '5px' }} {...this.props}>
          <TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
          <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
            <FormDataConsumer>
              {({ formData }) => setFormData(formData) }
            </FormDataConsumer>
            <div>
              <SelectInput label="Date Range" source="date_range"
                onChange={value => this.setState({ dateRange: value.target.value })}
                choices={dateRangeChoices}
                defaultValue="8"
                disabled={loading} />
              <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
                <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                    style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} />
                </div>
              </div>
					  </div>
            <SelectArrayInput label="Show" 
              source="show" 
              choices={choicesShow}
              style={{ width: '400px', flexGrow: 1}}
              disabled={loading} />
          </div>
            
            <div style={{ width: '100%', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper3">
              <div style={{flex: 1}}>
                <ReferenceArrayInput 
                  source="bidder_id" 
                  label="Bidder" 
                  reference="bidders"
                  basePath='bidders'
                  sort={{ field: 'name', order: 'ASC' }}
                  filterToQuery={searchText => ({ search_name: searchText })}
                  allowEmpty
                  disabled={loading} >
                  <AutocompleteArrayInput label="Bidder" optionText={record => (record && record.name)?`${record.name} (${record.code})`:""}
                    optionValue="code" fullWidth/>
                </ReferenceArrayInput>
              </div>
              <div style={{flex: 1}}>
              <ReferenceArrayInput 
                source="domain_id"
                label="Domain" 
                reference="domains"
                basePath='domains'
                sort={{ field: 'name', order: 'ASC' }}
                filterToQuery={searchText => ({ search_name: searchText })}
                allowEmpty
                disabled={loading} >
                <AutocompleteArrayInput label="Domain" optionText={record => (record && record.name)?`${record.name} (${record.type})`:""}
                  optionValue="code" fullWidth/>
              </ReferenceArrayInput>
              </div>
              <div style={{flex: 1}}>
              <SelectInput label="Type" source="type" choices={choicesType} disabled={loading}/>
              </div>
            </div>
        </SimpleForm>
        <div style={{ height: '5px' }} />
        
        <div style={{ height: '5px' }} />
        <DataTable
          title="Adstxt Coverage"
          theme="dark"
          columns={this.state.columns}
          data={data}
          progressPending={loading}
          pagination
          fixedHeader
          paginationPerPage={30}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
          dense
          highlightOnHover
          subHeader={!loading}
          subHeaderComponent={
            (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input type="text" id='search_box' label="Search" 
                variant="outlined" 
                style={{ margin: '5px' }} 
                onChange={(target) => dataSupport.filterData(this)}/>
                <CloudDownload 
                label="Export"
                style={{ margin: '5px' }} 
                color="action" 
                onClick={() => dataSupport.exportData(this.state.data)}
                />
              </div>
            )
          }
        />
      </div>
    )
  }
};
export const AdstxtReportEdit = ({ permissions, ...props }) => {
  return (
    <Edit title={<Title />} {...props}>
      <ReportComponent formType="edit" permissions={permissions} {...props}/>
    </Edit>
  )
}
export const AdstxtReportCreate = ({ permissions, ...props }) => {
  return (
    <Create title={<Title />}  {...props}>
      <ReportComponent formType="create" permissions={permissions} {...props}/>
    </Create>
  )
}
